// App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate, useNavigate } from 'react-router-dom';
import { UserProvider } from './context/UserContext'; // Import the UserProvider
import { UserLoginProvider } from './context/AuthContext';

//import VideoAd from './components/VideoAd';
import OTPForm from './components/OTPForm';
import VideoForm from './components/VideoForm';
import OccupationSurvey from './components/OccupationSurveyForm';
import UserInformationForm from './components/UserInformationForm';
import VideoFormCnt from './components/VideoFormCnt';
import Completed from './components/Completed';
import Layout from './components/Layout';
import DecisionSurvey from './components/DecisionSurvey';
import VideoCloseForm from './components/VideoCloseForm';
import UserDetailsForm from './components/UserDetailsForm';
import Register from './components/Register';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './components/dashboard/Dashboard';
import RedirectBasedOnQueryParam from './components/RedirectBasedOnQueryParam';
import { initFacebookPixel } from './types/facebookPixel';
import RouteChangeTracker from './fbTracker/RouteChangeTracker';
import { LanguageProvider } from "./context/LanguageContext";
import ChangePassword from './components/user/ChangePassword';
import UserSettings from './components/user/UserSettings';
import MyProfile from './components/user/MyProfile';
import ReportDashboard from "./components/reports/ReportDashboard";

const App: React.FC = () => {
  useEffect(() => {
    const pixelId = process.env.REACT_APP_FACEBOOK_PIXEL_ID || '';

    if (!pixelId) {
      if (process.env.NODE_ENV === "development") {
        console.warn("⚠️ Facebook Pixel ID is missing. Add REACT_APP_FACEBOOK_PIXEL_ID in .env");
      }
      return;
    }

    // 👇 Only init (no default pageView here, to avoid duplicates)
    initFacebookPixel(pixelId);
  }, []);

  return (
    <LanguageProvider>
      <UserLoginProvider>
        <UserProvider>
          <Router>
            <RouteChangeTracker />
            <Layout>
              <Routes>
                <Route path="/" element={<RedirectBasedOnQueryParam />} />
                <Route path="/join" element={<OTPForm />} />
                <Route path="/video" element={<VideoForm />} />
                <Route path="/occupationSurvey" element={<OccupationSurvey />} />
                <Route path="/userInFormatin" element={<UserInformationForm />} />
                <Route path="/videoFormCnt" element={<VideoFormCnt />} />
                <Route path="/completed" element={<Completed />} />
                <Route path="/decisionSurvey" element={<DecisionSurvey />} />
                <Route path="/videoCloseForm" element={<VideoCloseForm />} />
                <Route path="/userDetailsForm" element={<UserDetailsForm />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<RedirectBasedOnQueryParam />} />
                <Route element={<PrivateRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/my-profile" element={<MyProfile />} />
                  <Route path="/change-password" element={<ChangePassword />} />
                  <Route path="/user-settings" element={<UserSettings />} />
                  <Route path="/reports-monthly-lead" element={<ReportDashboard />} />
                </Route>
              </Routes>
            </Layout>
          </Router>
        </UserProvider>
      </UserLoginProvider>
    </LanguageProvider>
  );
};
export default App;

